export default [
  {
    id: 1,
    nm: "Product Preview Card",
    tech: "HTML / CSS",
    live: "https://product-preview-card-component-3ik.pages.dev",
    rep: "https://github.com/ShiroNhL2077/Product-preview-card-component",
  },
  {
    id: 2,
    nm: "Rating Component",
    tech: "HTML / CSS / JS",
    live: "https://interactive-rating-component-1aw.pages.dev",
    rep: "https://github.com/ShiroNhL2077/Interactive-rating-component",
  },
  {
    id: 3,
    nm: "To do list",
    tech: "React JS / CSS",
    live: "https://my-to-do-list.pages.dev",
    rep: "https://github.com/ShiroNhL2077/my-to-do-list",
  },
  {
    id: 4,
    nm: "Loading state",
    tech: "HTML / CSS / JS",
    live: "https://loading-state.pages.dev",
    rep: "https://github.com/ShiroNhL2077/loading-state",
  },
  {
    id: 5,
    nm: "Color onHover",
    tech: "HTML / CSS / JS",
    live: "https://color-onhover.pages.dev",
    rep: "https://github.com/ShiroNhL2077/color-onHover",
  },
  {
    id: 6,
    nm: "Auto Switch",
    tech: "HTML / CSS / JS",
    live: "https://auto-switch.pages.dev",
    rep: "https://github.com/ShiroNhL2077/auto-Switch",
  },
  {
    id: 7,
    nm: "Follows counter",
    tech: "HTML / CSS / JS",
    live: "https://follows-counter.pages.dev",
    rep: "https://github.com/ShiroNhL2077/follows-counter",
  },
  {
    id: 8,
    nm: "Anime website Home Page",
    tech: "HTML / CSS / JS",
    live: "https://homepage-ayn.pages.dev",
    rep: "https://github.com/ShiroNhL2077/homePage",
  }
];
